import { render } from "./IsFavouriteIndicator.vue?vue&type=template&id=f70fb07c&scoped=true"
import script from "./IsFavouriteIndicator.vue?vue&type=script&lang=js"
export * from "./IsFavouriteIndicator.vue?vue&type=script&lang=js"

import "./IsFavouriteIndicator.vue?vue&type=style&index=0&id=f70fb07c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f70fb07c"]])

export default __exports__